import * as React from 'react';
import { Props } from 'react';

import { Hotel } from '../../../../models/Hotels/Hotel';
import './HotelPoliciesView.scss';
import i18next from 'i18next';

const checkInIcon = require('../../../../assets/hotel_check-in_icon.svg');
const informationIcon = require('../../../../assets/information_icon.svg');
const childrensIcon = require('../../../../assets/hotel_childrens_icon.svg');
const depositIcon = require('../../../../assets/hotel_deposit_icon.svg');
const additionalServicesIcon = require('../../../../assets/hotel_additional_services_icon.svg');
const childrenFoodIcon = require('../../../../assets/children_food_icon.svg');
const cradleIcon = require('../../../../assets/hotel_cradle_icon.svg');
const extraBedIcon = require('../../../../assets/additional_bed_icon.svg');
const internetIcon = require('../../../../assets/hotel_wifi_icon.svg');
const parkingIcon = require('../../../../assets/hotel_parking_icon.svg');
const transferIcon = require('../../../../assets/hotel_transfer_icon.svg');
const petsIcon = require('../../../../assets/hotel_pets_icon.svg');
const foodIcon = require('../../../../assets/hotel_food_icon.svg');
/*const earlyCheckInIcon = require('../../../../assets/hotel_early_ckeck-in_icon.svg');*/

export interface HotelPoliciesViewProps extends Props<HotelPoliciesView> {
    hotel: Hotel;
}

interface HotelPoliciesViewState {
    groupOpened: number;
}

export class HotelPoliciesView extends React.Component<HotelPoliciesViewProps, HotelPoliciesViewState> {

    state: HotelPoliciesViewState = {
        groupOpened: 0
    };

    constructor(props: HotelPoliciesViewProps) {
        super(props);
        window.scrollTo(0, 0);
    }

    renderCheckInConditions() {
        const {hotel} = this.props;
        return (
            <div>
                {hotel.check_in_time && <div>
                    <div className='policy-subtitle'>
                        <img src={checkInIcon} />
                        {i18next.t('check-in_and_check-out')}
                    </div>
                    <div className='policy-text'>
                        {`${i18next.t('check-in')}: ${i18next.t('check-in_from')} ${hotel.check_in_time.substr(0, 5)}`}
                    </div>
                    <div className='flex'>
                        <div className='timeline' style={{width: `${Number(hotel.check_in_time.substr(0, 2)) / 24 * 100}%`}}>
                            <div className='time'>
                                {hotel.check_in_time.substr(0, 5)}
                            </div>
                        </div>
                        <div className='timeline active' style={{width: `${(24 - Number(hotel.check_in_time.substr(0, 2))) / 24 * 100}%`}} />
                    </div>
                    {hotel.check_out_time && <div>
                        <div className='policy-text'>
                            {`${i18next.t('check-out')}: ${i18next.t('check-out_before')} ${hotel.check_out_time.substr(0, 5)}`}
                        </div>
                        <div className='flex'>
                            <div className='timeline active' style={{width: `${Number(hotel.check_out_time.substr(0, 2)) / 24 * 100}%`}}>
                                <div className='time'>
                                    {hotel.check_out_time.substr(0, 5)}
                                </div>
                            </div>
                            <div className='timeline' style={{width: `${(24 - Number(hotel.check_out_time.substr(0, 2))) / 24 * 100}%`}} />
                        </div>
                    </div>}
                </div>}
                {hotel.metapolicy_struct && hotel.metapolicy_struct.no_show && hotel.metapolicy_struct.no_show.time &&
                <div className='policy-subtitle'>
                    <div className='flex'>
                        <img src={informationIcon} style={{height: '19px', marginTop: '9px'}}/>
                        <div className='policy-text'>
                            {i18next.t('no-show_policy', { when: i18next.t(`${hotel.metapolicy_struct.no_show.day_period}`), time: hotel.metapolicy_struct.no_show.time.substr(0, 5) })}
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    renderPaidLocally() {
        const {metapolicy_struct} = this.props.hotel;
        if (metapolicy_struct) {
            return (
                <div>
                    {metapolicy_struct.children && metapolicy_struct.children.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={childrensIcon} />
                            {i18next.t('childrens')}
                        </div>
                        {metapolicy_struct.children.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(i18next.t('hotel_children_policy', { from: policy.age_start && policy.age_start !== 0 ? `${i18next.t('small_from')} ${policy.age_start}` : '', to: policy.age_end && policy.age_end !== 0 ? `${i18next.t('check-out_before')} ${policy.age_end}` : ''}), policy.price, policy.currency)}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.deposit && metapolicy_struct.deposit.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={depositIcon} />
                            {i18next.t('deposit')}
                        </div>
                        {metapolicy_struct.deposit.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(i18next.t(`${policy.deposit_type}`), policy.price, `${policy.currency} ${i18next.t(policy.payment_type)} `, i18next.t(policy.price_unit))}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.add_fee && metapolicy_struct.add_fee.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={additionalServicesIcon} />
                            {i18next.t('add_fee')}
                        </div>
                        {metapolicy_struct.add_fee.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(i18next.t(`${policy.fee_type}`), `${policy.price.replace('.00', '')} ${policy.currency} `, i18next.t(policy.price_unit))}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.children_meal && metapolicy_struct.children_meal.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={childrenFoodIcon} />
                            {i18next.t('children_meal')}
                        </div>
                        {metapolicy_struct.children_meal.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(i18next.t(`${policy.meal_type}`), policy.price, `${policy.currency} ${i18next.t('from_guest')} (${i18next.t('age_child', {from: policy.age_start && policy.age_start !== 0 ? `${i18next.t('small_from')} ${policy.age_start}` : '', to: policy.age_end && policy.age_end !== 0 ? `${i18next.t('check-out_before')} ${policy.age_end}` : ''})})`)}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.cot && metapolicy_struct.cot.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={cradleIcon} />
                            {i18next.t('cot')}
                        </div>
                        {metapolicy_struct.cot.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.amount === 0 ? i18next.t('need_clarify') : '', policy.price, policy.currency, i18next.t(policy.price_unit))}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.extra_bed && metapolicy_struct.extra_bed.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={extraBedIcon} />
                            {i18next.t('extra_bed')}
                        </div>
                        {metapolicy_struct.extra_bed.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.amount === 0 ? i18next.t('need_clarify') : '', policy.price, policy.currency, i18next.t(policy.price_unit))}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.internet && metapolicy_struct.internet.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={internetIcon} />
                            {i18next.t('internet')}
                        </div>
                        {metapolicy_struct.internet.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.internet_type !== 'unspecified' ? `${i18next.t(policy.internet_type)}${policy.work_area ? i18next.t(`in_${policy.work_area}`) : ''}` : policy.work_area && i18next.t(`big_in_${policy.work_area}`), policy.price, policy.currency, i18next.t(policy.price_unit))}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.meal && metapolicy_struct.meal.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={foodIcon} />
                            {i18next.t('meal')}
                        </div>
                        {metapolicy_struct.meal.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(i18next.t(`${policy.meal_type}`), policy.price, `${policy.currency} ${i18next.t('from_guest')}`)}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.parking && metapolicy_struct.parking.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={parkingIcon} />
                            {i18next.t('parking')}
                        </div>
                        {metapolicy_struct.parking.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.territory_type === 'unspecified' ? i18next.t('need_clarify') : i18next.t(policy.territory_type), policy.price, policy.currency, `${i18next.t('per_auto')} ${i18next.t(`short_${policy.price_unit}`)}`)}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.shuttle && metapolicy_struct.shuttle.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={transferIcon} />
                            {i18next.t('transfers')}
                        </div>
                        {metapolicy_struct.shuttle.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.destination_type === 'unspecified' ? i18next.t('need_clarify') : `${i18next.t(policy.destination_type)} ${policy.shuttle_type === 'two_ways' ? i18next.t('and_back') : ''}`, policy.price, policy.currency)}
                                </div>
                            );
                        })}
                    </div>
                    }
                    {metapolicy_struct.pets && metapolicy_struct.pets.length > 0 && <div>
                        <div className='policy-subtitle'>
                            <img src={petsIcon} />
                            {i18next.t('pets')}
                        </div>
                        {metapolicy_struct.pets.map((policy, i) => {
                            console.log(policy);
                            return (
                                <div className='service' key={i}>
                                    {this.renderService(policy.pets_type === 'unspecified' ? i18next.t('need_clarify') : i18next.t(policy.pets_type), policy.price, policy.currency, `${i18next.t('per_pet')} ${i18next.t(`short_${policy.price_unit}`)}`)}
                                </div>
                            );
                        })}
                    </div>
                    }
                </div>
            );
        } else {
            return ;
        }
    }

    renderService(description: string, price: string, currency: string, unit?: string) {
        return (
            <div>
                {description.length > 0 && <div className='policy-text'>
                    {description}
                </div>}
                <div className='policy-text' style={{marginTop: '0'}}>
                    {i18next.t('price') + ': '}
                    <b style={{color: 'rgba(0, 0, 0, 0.88)'}}>
                        {price === '0.00' || !currency ? i18next.t('need_clarify') : `${price.replace('.00', '')} ${currency} ${unit ? unit : ''}`}
                    </b>
                </div>
            </div>
        );
    }

    isServicesLen() {
        const {hotel} = this.props;
        const metapolicies = hotel.metapolicy_struct;
        if (!metapolicies || metapolicies.meal.length === 0 && metapolicies.parking.length === 0 &&
            metapolicies.internet.length === 0 && metapolicies.pets.length === 0 && metapolicies.shuttle.length === 0 &&
            metapolicies.extra_bed.length === 0 && metapolicies.cot.length === 0 && metapolicies.children_meal.length === 0 &&
            metapolicies.deposit.length === 0 && metapolicies.add_fee.length === 0 && metapolicies.children.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    render() {
        const {hotel} = this.props;
        const {groupOpened} = this.state;
        if (hotel) {
            return (
                <div className='hotel-policies-container'>
                    <div className='policy-header' style={{marginBottom: '12px'}}>{hotel.name}</div>
                    <div className='policy-header'>{i18next.t('policies')}</div>
                    <div className={`hotel-policy${groupOpened === 1 ? ' opened' : ''}`} onClick={() => this.setState({groupOpened: groupOpened === 1 ? 0 : 1})}>
                        {i18next.t('check-in_conditions')}
                        {groupOpened === 1 && this.renderCheckInConditions()}
                    </div>
                    {hotel.metapolicy_struct && this.isServicesLen() && <div className={`hotel-policy${groupOpened === 2 ? ' opened' : ''}`} onClick={() => this.setState({groupOpened: groupOpened === 2 ? 0 : 2})}>
                        {i18next.t('paid_locally')}
                        {groupOpened === 2 && this.renderPaidLocally()}
                    </div>}
                    {hotel.metapolicy_struct && hotel.metapolicy_struct.visa.visa_support === 'support_enable' && <div className={`hotel-policy${groupOpened === 3 ? ' opened' : ''}`} onClick={() => this.setState({groupOpened: groupOpened === 3 ? 0 : 3})}>
                        {i18next.t('visa_information')}
                        {groupOpened === 3 && <div className='policy-text'>
                            {i18next.t(`hotel_visa_${hotel.metapolicy_struct.visa.visa_support}`)}
                        </div>}
                    </div>}
                    {hotel.metapolicy_extra_info && <div className={`hotel-policy${groupOpened === 4 ? ' opened' : ''}`} onClick={() => this.setState({groupOpened: groupOpened === 4 ? 0 : 4})}>
                        {i18next.t('additional_information')}
                        {groupOpened === 4 &&
                        <div>
                            <div className='policy-text'>
                                {hotel.metapolicy_extra_info}
                            </div>
                        </div>}
                    </div>}
                </div>
            );
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Hotels/Hotel/HotelPolicies/HotelPoliciesView.tsx